import React from 'react'

const Column=({children,custom})=>
{
    const Items=children.length;
    const Porcentaje = 100 / Items;
    var Largo="";
    Array.from({length:Items}).map(() => Largo+=`${Porcentaje}% `);
    
    var style=undefined;
    if(custom)
    {
        style=custom;
    }
    else
    {
        style={display:"grid",gridTemplateColumns:Largo,alignItems:"center"}
    }

    return <div style={style}>
        {children}
    </div>
}
export default Column;